<template>
    <div class="w-100 px-2">
        <v-row class="px-2 py-2" v-if="profile && !isConsultation">
            <v-col cols="1">
                <v-btn-back @click="back()"> </v-btn-back>
            </v-col>
            <v-col cols="3">
                <v-text-field
                    v-model="profile.displayName"
                    label="Nom du profil"
                    hide-details
                    :rules="[(v) => !!v || 'Le nom du profil est requis']"
                    :readonly="readonly"
                    density="compact"
                    :disabled="readonly"
                />
            </v-col>
            <v-col cols="2">
                <v-select
                    v-model="profile.type"
                    :items="profileTypes"
                    item-value="value"
                    :item-title="(item: any) => item.text"
                    label="Type"
                    hide-details
                    :readonly="readonly"
                    density="compact"
                    :disabled="readonly"
                />
            </v-col>
            <v-col cols="2">
                <v-select
                    v-model="profile.restrictionLevel"
                    :items="restrictionLevels"
                    label="Niveau de restriction"
                    outlined
                    hide-details
                    :readonly="readonly"
                    density="compact"
                    :disabled="readonly"
                />
            </v-col>
            <v-col cols="2">
                <v-select
                    v-model="profile.homePage"
                    :items="homePages"
                    label="Page de démarrage"
                    outlined
                    hide-details
                    :readonly="readonly"
                    density="compact"
                    :disabled="readonly"
                />
            </v-col>
            <v-col cols="2" class="d-flex justify-end pr-4">
                <v-tooltip bottom v-if="profile.originalProfileId">
                    <template v-slot:activator="{ props }">
                        <v-btn
                            class="mr-2"
                            small
                            fab
                            elevation="0"
                            v-bind="props"
                            color="#FFF"
                            @click="checksDialog = true"
                        >
                            <v-badge color="red" :content="errorsCount">
                                <v-icon color="primary" class="pb-1">$oss-warning</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <span>Contrôle de droits</span>
                </v-tooltip>

                <v-btn-edit @click="update()" :disabled="readonly || errorsCount > 0"> </v-btn-edit>
            </v-col>
        </v-row>
        <v-row no-gutters class="d-flex justify-center default_card pt-2 pb-0">
            <v-col cols="12">
                <div class="configuration-searchinput pb-3">
                    <v-text-field-filled
                        v-model="search"
                        label="Rechercher"
                        outlined
                        hide-details
                        width="100%"
                        density="compact"
                        append-inner-icon="$search"
                        clearable
                        @click:clear="search = ''"
                    />
                </div>
                <div style="height: calc(100vh - 230px); overflow-y: auto">
                    <template v-for="(values, keyTitle, index) in profile.configuration">
                        <template v-if="displaySection(keyTitle)">
                            <v-divider :key="`d-${keyTitle}-title`" v-if="index" />
                            <v-row
                                no-gutters
                                :key="`${keyTitle}-title`"
                                class="mb-4 configuration-title"
                            >
                                <v-col class="configuration-value ma-0 title mt-2">
                                    {{ $t(`profile.${keyTitle}.title`) }}
                                </v-col>
                                <v-col class="pt-2">
                                    <v-radio-group
                                        v-model="profile.readWrites[keyTitle].readWrite"
                                        inline
                                        density="compact"
                                        color="primary"
                                        v-if="profile.readWrites[keyTitle]"
                                        hide-details
                                        class="mt-0"
                                        @change="onChangeReadWrite"
                                        :readonly="readonly"
                                        :disabled="isConsultation"
                                    >
                                        <v-radio label="Pas d'accès" :value="0" />
                                        <v-radio
                                            label="Lecture"
                                            :value="1"
                                            :disabled="
                                                refProfile.readWrites[keyTitle].readWrite < 1 &&
                                                profile.originalProfileId != null
                                            "
                                        />
                                        <v-radio
                                            label="Lecture/Ecriture"
                                            :value="3"
                                            :disabled="
                                                refProfile.readWrites[keyTitle].readWrite < 2 &&
                                                profile.originalProfileId != null
                                            "
                                        />
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <template v-for="(conf, keyConf) in values">
                                <v-row
                                    no-gutters
                                    v-if="displayConfig(keyTitle, keyConf)"
                                    :key="`${keyTitle}-${keyConf}`"
                                    class="configuration-value"
                                >
                                    <v-col class="d-flex align-center">
                                        <!-- {{ $t(`profile.${keyTitle}.values.${ keyConf }`) }} -->
                                    </v-col>
                                    <v-col>
                                        <v-switch
                                            v-model="profile.configuration[keyTitle][keyConf]"
                                            hide-details
                                            class="pt-0 mt-0"
                                            color="primary"
                                            :ripple="!isConsultation"
                                            @change="onChangeReadWrite"
                                            :label="$t(`profile.${keyTitle}.values.${keyConf}`)"
                                            :readonly="readonly ||&#xa0;isConsultation"
                                            :disabled="
                                                checkForSliderRight(
                                                    originalProfile.configuration[keyTitle][
                                                        keyConf
                                                    ],
                                                    profile.configuration[keyTitle][keyConf],
                                                )
                                            "
                                        />
                                    </v-col>
                                </v-row>
                            </template>
                        </template>
                    </template>
                </div>
            </v-col>
            <oss-dialog
                v-if="checksDialog"
                v-model="checksDialog"
                title="Contrôle des droits"
                @close="checksDialog = false"
                width="30vw"
            >
                <v-row no-gutters>
                    <v-col cols="12">
                        <template v-if="!errorsCount">
                            <h3 class="text-center my-5">
                                <v-icon class="mr-2" color="primary">$oss-circle-check</v-icon>
                                Tous les contrôles ont été validés
                            </h3>
                        </template>
                        <template v-else>
                            <h4 v-if="errorsCount = 1">{{ errorsCount }} droit surélévé :</h4>
                            <h4 v-if="errorsCount > 1">{{ errorsCount }} droits surélévés :</h4>
                            <h4
                                v-for="errorMessage in errorMessages"
                                :key="errorMessage"
                                class="mr-2"
                            >
                                <v-icon class="mr-2" color="red">$oss-warning</v-icon>
                                {{ errorMessage }}
                            </h4>
                        </template>
                    </v-col>
                </v-row>
            </oss-dialog>
        </v-row>
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import PROFILE from "../../graphql/Profile.gql";
import UPDATE_PROFILE from "../../graphql/UpdateProfile.gql";
import CREATE_PROFILE from "../../graphql/CreateProfile.gql";
import { Apollo } from "@/decorators";
import {
    defaultConfiguration,
    ProfileConfiguration,
} from "../../../../backend/src/common/profile/profile";
import { User } from "../../store/store";
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";
import { compareConfigurationProfiles } from "@/services/accessRightServices";

export class UserProfile {
    id: string = "";
    displayName: string = "";
    name: string = "";
    type: string = "";
    originalProfileId: string = "";
    restrictionLevel: number = 1;
    test: boolean = false;
    configuration: ProfileConfiguration;
    readWrites = {};
    homePage: any;

    constructor() {
        this.configuration = _.cloneDeep(defaultConfiguration);
    }

    checkReadWrites(configuration: ProfileConfiguration) {
        for (const key in configuration) {
            const conf = configuration[key];
            if (conf.read !== undefined && conf.write !== undefined) {
                let readWrite = 0;
                if (conf.read) {
                    readWrite = 1;
                }
                if (conf.write) {
                    readWrite += 2;
                }
                this.readWrites[key] = {
                    readWrite,
                };
            }
        }
    }

    updateReadWrite() {
        for (const key in this.readWrites) {
            const readWrite = this.readWrites[key].readWrite;
            const conf = this.configuration[key];
            if (readWrite === 0) {
                conf.read = false;
                conf.write = false;
            } else if (readWrite === 1) {
                conf.read = true;
                conf.write = false;
            } else if (readWrite === 3) {
                conf.read = true;
                conf.write = true;
            } else {
                debugger;
            }
        }
    }
}

@Component
export class Profile extends Vue {
    @Prop({ type: String }) profileId: string;

    /**
     * Set the readonly value of the fields of the component
     */
    @Prop({ type: Boolean }) isConsultation: boolean;
    checksDialog: boolean = false;
    id_: string = "";
    // profile: any = null

    get id() {
        if (this.id_) {
            return this.id_;
        }
        if (this.profileId) {
            return this.profileId;
        }
        return null;
    }

    set id(data) {
        this.id_ = data;
    }

    get idClone() {
        return this.$route.params.idClone;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get readonly() {
        //If the prop is set to true, we put all the fields in readonly, remove the validation of the form and the profile row
        if (this.isConsultation) {
            return true;
        } else {
            return !this.currentUser.profile?.configuration?.profile?.write;
        }
    }

    get profileTypes() {
        const profileTypes = [];
        if (this.currentUser.profile.type === "ROOT") {
            profileTypes.push({ text: "Racine", value: "ROOT" });
            profileTypes.push({ text: "Cabinet", value: "ACCOUNTING" });
            profileTypes.push({ text: "Client du cabinet", value: "ACCOUNTING_CLIENT" });
            profileTypes.push({ text: "Entreprise", value: "BUSINESS" });
        }
        if (this.currentUser.profile.type === "ACCOUNTING") {
            profileTypes.push({ text: "Cabinet", value: "ACCOUNTING" });
            profileTypes.push({ text: "Client du cabinet", value: "ACCOUNTING_CLIENT" });
        }
        if (this.currentUser.profile.type === "ACCOUNTING_CLIENT") {
            profileTypes.push({ text: "Entreprise", value: "ACCOUNTING_CLIENT" });
        }
        if (this.currentUser.profile.type === "BUSINESS") {
            profileTypes.push({ text: "Entreprise", value: "BUSINESS" });
        }
        return profileTypes;
    }

    get restrictionLevels() {
        const restrictionLevels = [];
        let maxCount = 2;
        if (
            this.currentUser.profile.type === "ROOT" ||
            this.currentUser.profile.type === "ACCOUNTING"
        ) {
            maxCount = 3;
        }
        for (let index = this.currentUser.profile.restrictionLevel; index < maxCount; index++) {
            restrictionLevels.push(index);
        }
        return restrictionLevels;
    }

    search = "";

    homePages = [
        "home",
        "bank",
        "dashboard",
        "documents",
        "accountingItems",
        "accountingItem",
        "ztillReceipts",
        "zTillReceipt",
        "ztillReceiptNew",
        // 'newsFeed',
        // 'toBeDone',
        // 'toBeDone/reconciliation',
        "settings",
        // 'password-recovery',
        // 'password-reset',
        "exportAccounting",
        // "vatDeclarations",
        // "vatDeclarationNew",
        // 'vatDeclaration',
        // 'budgetInsightCallback',
        "budgets",
        "expenseReports",
        "users-activities",
        "invoices",
        "invoiceNew",
        "invoiceEdition",
        "quotationNew",
        "quotationEdition",
        "accountant-home",
    ];

    errorMessages: string[] = [];

    get errorsCount(): number {
        if (this.errorMessages?.length) {
            return this.errorMessages.length;
        }
        return 0;
    }

    /**
     * Check for duplicateProfile, and if the slider should be disabled given the parameters passed
     * @param originalProfileConfiguration boolean : is used for slider, represent a right of the originalProfile
     * @param actualProfileConfiguration boolean : is used for slider, represent a right of the profile being modified
     * @returns boolean, false if the right should be enabled
     */
    checkForSliderRight(
        originalProfileConfiguration: boolean,
        actualProfileConfiguration: boolean,
    ): boolean {
        return (
            originalProfileConfiguration == false &&
            actualProfileConfiguration != true &&
            this.profile.originalProfileId != null
        );
    }

    async update() {
        let displayName = "";
        if (!this.profile.displayName && this.profile.name) {
            displayName = this.$t(`profiles.name.${this.profile.name}`).toString();
        } else {
            displayName = this.profile.displayName;
        }

        if (this.profile.name || this.profile.displayName) {
            this.profile.updateReadWrite();
            const profile = {
                type: this.profile.type,
                name: this.profile.name,
                displayName: displayName,
                restrictionLevel: this.profile.restrictionLevel,
                test: this.profile.test,
                configuration: this.profile.configuration,
                homePage: this.profile.homePage,
            };
            if (this.id) {
                await this.$apollo.mutate({
                    mutation: UPDATE_PROFILE,
                    variables: {
                        id: this.id,
                        profile: profile,
                    },
                });
            } else {
                const newProfile = await this.$apollo.mutate({
                    mutation: CREATE_PROFILE,
                    variables: {
                        profile: profile,
                    },
                });

                this.id = newProfile.data.createProfile.id;
                this.$router.push({
                    name: "profile-edition",
                    params: {
                        id: this.id,
                    },
                });
            }
        }
    }

    back() {
        this.$router.go(-1);
    }

    updateConfig(section: string, config: string) {
        this.profile.configuration[section][config] = !this.profile.configuration[section][config];
    }

    displayConfig(keyTitle: string, keyConf: string) {
        if (this.profile.readWrites[keyTitle] && (keyConf === "read" || keyConf === "write")) {
            return false;
        }
        if (!this.search) {
            return true;
        }
        const config = `profile.${keyTitle}.values.${keyConf}`;
        const translation = this.$t(config) as string;
        if (translation.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
            return true;
        }
        return this.displaySection(keyTitle, false);
    }

    displaySection(section: string, checkValues = true) {
        if (!this.search) {
            return true;
        }
        const config = `profile.${section}.title`;
        const translation = this.$t(config) as string;
        if (translation.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
            return true;
        }
        if (checkValues) {
            const values = Object.keys(this.profile.configuration[section]);
            return values.some((value: any) => this.displayConfig(section, value));
        }
        return false;
    }

    @Apollo({
        query: PROFILE,
        variables() {
            return {
                id: this.id ? this.id : this.idClone,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.id && !this.idClone;
        },
        async specificResult({ data, loading, networkStatus }) {
            if (data?.profile) {
                this.profile = Object.assign(new UserProfile(), data.profile, {});
                if (!this.profile?.displayName) {
                    if (this.profile?.name) {
                        this.profile.displayName = this.$t(
                            `profiles.name.${this.profile.name}`,
                        ).toString();
                    }
                }
                //To check for the rights for a duplicated profile, we need to load the original profile
                if (this.profile.originalProfileId) {
                    const dataOriginalProfile = await this.getOriginalProfile(
                        this.profile.originalProfileId,
                    );
                    this.originalProfile = Object.assign(
                        new UserProfile(),
                        dataOriginalProfile,
                        {},
                    );
                    //We need to calculate the rights for the original profile so we keep a reference as this.profile is updated
                    this.originalProfile.checkReadWrites(this.originalProfile.configuration);
                    this.profile.checkReadWrites(this.profile.configuration);
                    this.refProfile = _.cloneDeep(this.originalProfile);
                    this.errorMessages = await compareConfigurationProfiles(
                        this,
                        this.originalProfile.configuration,
                        this.profile.configuration,
                    );
                } else {
                    this.profile.checkReadWrites(this.profile.configuration);
                    this.refProfile = _.cloneDeep(this.profile);
                }
            }
        },
    })
    profile: UserProfile = new UserProfile();

    refProfile: UserProfile = new UserProfile();
    /**
     * Original profile of a duplicated profile, null if the profile isn't from a duplicated ones
     */
    originalProfile: UserProfile = new UserProfile();

    /**
     * Request to get original profile for comparison
     * @param id profile id
     */
    async getOriginalProfile(id: string) {
        try {
            const response = await this.$apollo.query({
                query: PROFILE,
                variables: { id: id },
                fetchPolicy: "network-only",
            });
            return response.data.profile;
        } catch (error) {
            console.error("Error fetching original profile: ", error);
            return null;
        }
    }

    /**
     * Check for elevated rights on duplicated profiles
     */
    async onChangeReadWrite() {
        if (this.profile.originalProfileId) {
            this.profile.updateReadWrite();
            this.errorMessages = await compareConfigurationProfiles(
                this,
                this.originalProfile.configuration,
                this.profile.configuration,
            );
        }
        await this.updateHomePagesRights();
    }

    /**
     * Updates the access rights for home pages based on the user's profile configuration
     * This method iterates through the config properties and calls the updatePageAccess method
     * to add or remove pages from the homePages array once the rights have been updated in the profile
     */
    async updateHomePagesRights() {
        const config = this.profile.configuration;
        const nameOfPagesToAdd: string[] = [];
        const nameOfPagesToRemove: string[] = [];
        // Mapping of pages and their corresponding access rights
        const pageAccessMap: { [key: string]: boolean } = {
            accountingItems: config.accounting.read,
            accountingItem: config.accounting.read,
            bank: config.bankAccount.read,
            dashboard: config.accounting.dashboard,
            exportAccounting: config.accounting.export,
            documents: config.document.read,
            budgets: config.budget.read,
            expenseReports: config.expenseReport.read,
            "users-activities": config.internalManagement.userActivity,
            invoices: config.accounting.read,
            invoiceNew: config.accounting.read,
            invoiceEdition: config.accounting.read,
            quotationNew: config.accounting.read,
            quotationEdition: config.accounting.read,
            "accountant-home": config.accounting.dashboard,
        };
        // Group pages to add and remove
        Object.entries(pageAccessMap).forEach(([page, hasAccess]) => {
            if (hasAccess) {
                if (!this.homePages.includes(page)) {
                    nameOfPagesToAdd.push(page);
                }
            } else {
                if (this.homePages.includes(page)) {
                    nameOfPagesToRemove.push(page);
                }
            }
        });
        // Perform updates in a single operation
        if (nameOfPagesToAdd.length > 0) {
            await this.addPages(nameOfPagesToAdd);
        }
        if (nameOfPagesToRemove.length > 0) {
            await this.removePages(nameOfPagesToRemove);
        }
    }
    /**
     * Adds multiple pages in a single operation
     * @param pages - The list of pages to add
     */
    async addPages(pages: string[]) {
        this.homePages = [...new Set([...this.homePages, ...pages])]; // Avoid duplicates
    }
    /**
     * Removes multiple pages in a single operation
     * @param pages - The list of pages to remove
     */
    async removePages(pages: string[]) {
        this.homePages = this.homePages.filter((page) => !pages.includes(page));
    }
}

export default toNative(Profile);
</script>

<style lang="scss" scoped>
.configuration-title {
    position: sticky;
    top: 0px;
    z-index: 1;
    background-color: #fff;
}

.configuration-value {
    transition: all 0.2s ease-in-out;
    padding: 0.6rem;
}

.configuration-value:hover {
    background-color: #f5f5f5;
}
</style>
